import { render, staticRenderFns } from "./AboutIndex.vue?vue&type=template&id=de39b6f8&"
import script from "./AboutIndex.vue?vue&type=script&lang=js&"
export * from "./AboutIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports